import { Fragment, startTransition } from 'react';
import { useReadQuery } from '@apollo/client/react';
import { SearchX } from 'lucide-react';

import { withSuspense } from 'src/hoc';
import Paginator from '@/components/ui/paginator';
import { EmptyBlock } from '@/components/ui/empty-block';
import { SoftwareDashboardSkeleton } from 'src/components/SoftwareDashboard';

import { useDashboard, DashboardItemContextProvider } from '../model';

import DashboardItem from './DashboardItem';

const ListContainer = () => {
  const { setPage, queryRef, page } = useDashboard();
  const {
    data: { softwareEscrows: dataEscrows },
  } = useReadQuery(queryRef);

  const onPageChange = (page: number) => startTransition(() => setPage(page));

  return (
    <Fragment>
      {!dataEscrows.nodesCount ? (
        <div className="absolute top-0 left-0 w-full h-full p-4 sm:p-6">
          <EmptyBlock
            title="No results found"
            description="There were no results for your search. Try another filter."
            icon={SearchX}
            classes={{
              title: 'text-base',
              card: 'h-full [&>div]:h-full',
              content: 'h-full flex flex-col justify-center',
            }}
          />
        </div>
      ) : (
        <div className="@container">
          <div className="grid grid-cols-1 @max-3xl:grid-cols-1 md:grid-cols-2 2xl:grid-cols-3 gap-6 mb-4">
            {dataEscrows.nodes.map(({ id }) => (
              <DashboardItemContextProvider key={id} id={id}>
                <DashboardItem />
              </DashboardItemContextProvider>
            ))}
          </div>
        </div>
      )}

      <Paginator
        currentPage={page}
        totalPages={dataEscrows.pagesCount}
        showPreviousNext
        hideOnSinglePage
        onPageChange={onPageChange}
      />
    </Fragment>
  );
};

export default withSuspense(ListContainer, SoftwareDashboardSkeleton);
